import React from 'react';
import PropTypes from 'prop-types';
import DashIcon from '@kyruus/react-ikons/Remove';
import { Box } from '@biome-design-system/ui/Box';

import { SwipeableBottomDrawer } from 'Src/shared/BottomSheet/SwipeableBottomDrawer';

function BottomSheet({
  headerText,
  children,
  isOpen,
  handleClose,
  className,
  ...rest
}) {
  return (
    <SwipeableBottomDrawer
      isOpen={isOpen}
      handleClose={handleClose}
      className={`${className || ''}`}
      {...rest}
    >
      <Box
        sx={{
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center'
        }}
      >
        <DashIcon size="24px" />
      </Box>
      {headerText && (
        <Box
          sx={{
            mb: 3,
            mx: 3
          }}
        >
          {headerText}
        </Box>
      )}
      <Box component="section" sx={{ overflowY: 'auto', height: '75vh' }}>
        {children}
      </Box>
    </SwipeableBottomDrawer>
  );
}

BottomSheet.propTypes = {
  headerText: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  children: PropTypes.node
};

export default BottomSheet;
